import {inject, Injectable} from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserLoginService } from "./user-login.service";
import { FeatureFlag } from '../models/feature-flag.model';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  _userLoginService = inject(UserLoginService);

  isEnabled(feature: FeatureFlag | string): boolean {
    const featureStr = feature.toString();
    const parts = featureStr.split('_');
    
    // Check naming-convention hierarchy (parent_child_subchild)
    if (parts.length > 1) {
        const parentCandidate = parts.slice(0, parts.length - 1).join('_');
        // Only enforce hierarchy if the parent is a recognized main feature
        if (Object.values(FeatureFlag).includes(parentCandidate as FeatureFlag)) {
            if (!this.isEnabled(parentCandidate)) {
                return false;
            }
        }
    }

    const clientFeatures = this._userLoginService.getUserObjectField('FEATURES')['features'];
    
    // Primary check
    if (clientFeatures.hasOwnProperty(featureStr)) {
        return clientFeatures[featureStr] === true;
    }
    
    return false;
  }

  isFeatureEnabled(featureFlag: FeatureFlag | string): boolean {
    return this.isEnabled(featureFlag) && !!(environment.featureFlags && environment.featureFlags[featureFlag.toString()]);
  }

  doesClientsHaveFeatures(features: (FeatureFlag | string)[]): boolean {
      return features.every((feature) => this.isEnabled(feature));
  }

  doesClientsHaveSettings(features: (FeatureFlag | string)[]): boolean {
      const clientSettings = this._userLoginService.getUserObjectField('CLIENT')['settings'];
      return features.every((feature) => {
          const featureStr = feature.toString();
          
          if (clientSettings.hasOwnProperty(featureStr)) {
              return clientSettings[featureStr] === true;
          }
          
          return false;
      });
  }
}
